import React, {Fragment, useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import FormSection from '../formSectionNew';
import localization from 'assets/localization/localization';
import DropDownInput from "../../Input/dropDownInput/dropDownInput";
import ConstantInput from "../../Input/constantInput/constantInput";
import Regex from "../../../../services/utils/regex/Regex";
import {handleValidateObj} from "../../../../constants/objValues/objvalues";
import CardSection from 'components/sales/cardSection/cardSection';
const AddPoc = ({handleValue, prefilledData}) => {
  const [inputList, setInputList] = useState([{id:"",pocName: "", pocDesVal: "", number: "", email: ""}, {
    id:"",
    pocName: "",
    pocDesVal: "",
    number: "",
    email: ""
  }, {id:"",pocName: "", pocDesVal: "", number: "", email: ""}]);
  useEffect(() => {
    if (
      prefilledData?.leads_poc !== undefined &&
      prefilledData?.leads_poc !== null
    ) {
      const leads_poc = prefilledData?.leads_poc;
      setTimeout(() => {
        if (leads_poc != '') {
          setInputList(leads_poc);
        } else {
          setInputList([{id:"",pocName: "", pocDesVal: "", number: "", email: ""}, {
            id:"",
            pocName: "",
            pocDesVal: "",
            number: "",
            email: ""
          }, {id:"",pocName: "", pocDesVal: "", number: "", email: ""}]);
        }
      }, 100);
    }
  }, [prefilledData]);
  const handleInputChange = (i, type, value) => {
    const list = [...inputList];
    list[i][type] = value;
    setInputList(list);
  };
  useEffect(() => {
    handlePocData();
  }, [inputList]);
  const handlePocData = () => {
    let isNotEmpty = true;
    let isEmailValid = true;
    let isPhoneValid = true;
    let vali = true;
    {
      inputList.map((x, i) => {
        if(prefilledData?.commercialData?.solution_type == 3 && i!=2){
          if (x.pocName == "" || x.pocDesVal == ""|| x.number=="") {
            isNotEmpty = false;
          }
          if (x.email && !Regex.email.test(x.email)) {
            isEmailValid = false;
          }
          if (!Regex.phoneNumber.test(x.number)) {
            isPhoneValid = false;
          }
        }
      })
    }
    if (isNotEmpty !== false && isEmailValid !== false && isPhoneValid !== false) {
      handleValue(
        inputList
      );
    } else {
      handleValue(null);
    }
  };
  
  
  return (
    <FormSection title={localization.pocTitle}>
      {inputList.map((pocData, i) => {
        return (
          <CardSection title={'POC ' + (i + 1)}>
            {/*<h4 className="panel-heading"></h4>*/}
            <div key={i} className="row">
              <div className="col-md-6">
                <ConstantInput
                  label={localization.POCName}
                  regex={Regex.text.test(pocData.pocName)}
                  errorMsg={
                    pocData.pocName
                      ? localization.requiredCharacter
                      : localization.requiredPocName
                  }
                  type="text"
                  handleChange={(val) => handleInputChange(i, 'pocName', val)}
                  required={true}
                  isStarRequired={prefilledData?.commercialData?.solution_type == 3 && i == 2 ? false : true}
                  value={pocData.pocName}
                />
              </div>
              <div className="col-md-6">
                <ConstantInput
                  label={localization.POCDesignation}
                  regex={Regex.text.test(pocData.pocDesVal)}
                  errorMsg={
                    pocData.pocDesVal
                      ? localization.requiredCharacter
                      : localization.requiredPocDesig
                  }
                  type="text"
                  handleChange={(val) => handleInputChange(i, 'pocDesVal', val)}
                  required={true}
                  isStarRequired={prefilledData?.commercialData?.solution_type == 3 && i == 2 ? false : true}
                  value={pocData.pocDesVal}
                />
              </div>
              <div className="col-md-6">
                <ConstantInput
                  label={localization.phoneNumber}
                  regex={Regex.phoneNumber.test(pocData.number)}
                  errorMsg={localization.requiredPhonenumber}
                  tenDigitsValidation={true}
                  maxLength={10}
                  minLength={10}
                  className="countrycode"
                  isPrefix
                  prefixText={'+91'}
                  type="number"
                  handleChange={(val) => {
                    handleInputChange(i, 'number', val)
                  }
                  }
                  required={true}
                  isStarRequired={prefilledData?.commercialData?.solution_type == 3 && i == 2 ? false : true}
                  value={pocData?.number !== 'undefined' ? pocData?.number : ''}
                />
              </div>
              <div className="col-md-6">
                <ConstantInput
                  label={localization.emailAddress}
                  regex={Regex.email.test(pocData.email)}
                  errorMsg={
                    pocData.email === ''
                      ? localization.emailAddressRequired
                      : localization.emailError
                  }
                  type="email"
                  handleChange={(val) =>
                    handleInputChange(i, 'email', val)
                  }
                  // required
                  // isStarRequired={true}
                  value={pocData.email}
                />
              </div>
            </div>
            {/*<hr/>*/}
          </CardSection>
        );
      })}
    </FormSection>
  );
};
AddPoc.propTypes = {
  handleValue: PropTypes.func
}
export default AddPoc;




